import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import { formatApiError } from '../i18n/apiErrorsT';

const LanguageContext = createContext({ lang: 'fr', setLang: () => {}, formatError: (m) => m });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('kio_lang') || 'fr';
  });

  const handleSetLang = (l) => {
    localStorage.setItem('kio_lang', l);
    setLang(l);
  };

  const formatError = useCallback((message) => formatApiError(lang, message), [lang]);

  const value = useMemo(
    () => ({ lang, setLang: handleSetLang, formatError }),
    [lang, formatError],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
